import {PasswordStrengthValidation, PasswordStrengthValidationConfig} from "@/features/auth/passwordStrengthValidation";
import {ReactIsland} from "@/shared/reactIsland";
import {
	mountPasswordStrengthIsland,
	type PasswordStrengthIslandCommands,
	type PasswordStrengthIslandProps,
} from "@/features/auth/passwordStrengthIsland";

export interface FinishInvitationSettingsConfig {
	passwordStrengthValidation?: PasswordStrengthValidation;
}

export class FinishInvitationSettingsPage {

	private static readonly ATTRIBUTE_DISABLED = "disabled";

	private readonly passwordStrengthIsland?: ReactIsland<PasswordStrengthIslandProps, PasswordStrengthIslandCommands>;
	private readonly passwordStrengthValidation?: PasswordStrengthValidationConfig;
	private readonly firstNameField: JQuery;
	private readonly passwordField: JQuery;
	private readonly submitButton: JQuery;

	constructor(private readonly config: FinishInvitationSettingsConfig) {
		this.passwordStrengthIsland = mountPasswordStrengthIsland("invitationPasswordStrengthIsland", config.passwordStrengthValidation);
		this.passwordStrengthValidation = config.passwordStrengthValidation ?
			new PasswordStrengthValidationConfig(config.passwordStrengthValidation) : undefined;
		this.firstNameField = $("#firstName");
		this.passwordField = $("#password");
		this.submitButton = $("button[type='submit']");

		this.initPasswordStrengthValidationListeners();
		this.setInitialFocus();
	}

	private validatePasswordStrength(input: string) {
		if (!this.passwordStrengthValidation) {
			return;
		}

		// The checklist UI now lives in the React island; here we only gate the submit button.
		this.updateSubmitButtonState(this.passwordStrengthValidation.validate(input).isValid);
	}

	private initPasswordStrengthValidationListeners() {
		this.passwordField.on("input", (event) => {
			const target = event.target as HTMLInputElement;
			this.passwordStrengthIsland?.dispatchCommand("passwordChanged", target.value);
			this.validatePasswordStrength(target.value);
		});
	}

	private setInitialFocus() {
		if (this.firstNameField.val() === "") {
			this.firstNameField.focus();
		} else {
			this.passwordField.focus();
		}
	}

	private updateSubmitButtonState(enabled: boolean) {
		if (enabled) {
			this.submitButton.removeAttr(FinishInvitationSettingsPage.ATTRIBUTE_DISABLED);
		} else {
			this.submitButton.attr(FinishInvitationSettingsPage.ATTRIBUTE_DISABLED, "");
		}
	}
}
